import {URL_BASE_API } from '../configs/urlConfigs';

import service from './api';

export const dashboardActionRequiredList = (request) => {     
    let ENDPOINT = '';

    ENDPOINT = URL_BASE_API+'events/dashboard-action-required/';

    return service.get(ENDPOINT);  
};

export const dashboardClientActionRequiredList = (request) => {     
    let ENDPOINT = '';

    ENDPOINT = URL_BASE_API+'events/dashboard-client-action-required/';

    return service.get(ENDPOINT);  
};

export const dashboardChartDataList = (request) => {     
    let ENDPOINT = '';
    let date_type = request.data.dateType;
    let days = request.data.days;
    let from_date = request.data.fromDate;
    let to_date = request.data.toDate;
    ENDPOINT = URL_BASE_API+'events/dashboard-chart-data/?date_type='+date_type+'&days='+days+'&from_date='+from_date+'&to_date='+to_date;

    return service.get(ENDPOINT);  
}; 

export const dashboardClientChartDataList = (request) => {     
    let ENDPOINT = '';
    let date_type = request.data.dateType;
    let days = request.data.days;
    let from_date = request.data.fromDate;
    let to_date = request.data.toDate;
    ENDPOINT = URL_BASE_API+'events/dashboard-client-chart-data/?date_type='+date_type+'&days='+days+'&from_date='+from_date+'&to_date='+to_date;

    return service.get(ENDPOINT);  
};

export const shiftTimeChangeRequestCount = (request) => {     
    let ENDPOINT =  URL_BASE_API+'events/shift-time-change-count/';
    return service.get(ENDPOINT);  
};